

import Element from 'element-ui';
import 'lib-flexible';
import './styles/index.scss';
import FastClick from 'fastclick'
import '@/assets/css/css_reset.css'; 

import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import { sync } from 'vuex-router-sync'
import i18n from './lang' 
import gRac from './plugins/rac'
import axios from 'axios';
import inject from './libs/inject'
import dsBridge from 'dsbridge'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'


Vue.prototype.$EventBus = new Vue();

Vue.use(inject,{});
Vue.use(ToastPlugin);

Vue.config.productionTip = false;
Vue.use(Element, {
size: 'medium', // set element-ui default size
i18n: (key, value) => i18n.t(key, value)
});







FastClick.attach(document.body);


sync(store, router);


Vue.use(gRac, {
store
});

new Vue({
el: '#app',
router,
store,
i18n,
template: '<App/>',
render: h => h(App)
});


// WEBPACK FOOTER //
// ./src/main.js